<template>
    <i class="messages huge ico-message pointer dark mr-3" @click="open" v-click-outside="close">

        <span class="number bold text-center lightest bg-brand">{{ messages.length }}</span>

        <div v-if="isVisible" class="box cursor-default">
            <div class="wrapper">
                <h5>People</h5>

                <div class="write fs-small border-light rounded p-2">
                    <i class="ico-search larger"></i>
                    <input type="text" @keyup="typing" placeholder="Type a name">
                </div>
            </div>
            
            <ul class="list" v-if="messages">
                <li v-for="item in messages" :class="!item.is_read ? 'normal' : 'bold'">
                    <img src="/static/images/avatar.png" alt="">

                    <div class="details ml-3">
                        <p>{{ item.user }}</p>
                        <p>{{ item.intro | ellipsis(45) }}</p>
                    </div>
                </li>
            </ul>
            <div v-else>
                <p>You have no messages.</p>
            </div>

            <div class="options bg-faded border-top-light text-right">
                <a href="#">View all</a>
            </div>
        </div>
    </i>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        created: function() {
            this.fetchMessages();
        },
        data: function() {
            return {
                isVisible: false,
            }
        },
        computed: {
            ...mapGetters([
                'getMessages'
            ]),
            messages: function() {
                return this.getMessages;
            }
        },
        methods: {
            ...mapActions([
                'fetchMessages'
            ]),
            open: function() {
                this.isVisible = true;
            },
            close: function() {
                this.isVisible = false;
            },
            typing: function(e) {
                var text = e.target.value;

                if (text.length > 2) {
                    var filtered = this.messages.filter(i => {
                        return i.user.toLowerCase().indexOf(text.toLowerCase()) !== -1; 
                    });

                    this.messages = filtered;
                }
                else {
                    this.messages = this.messages;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Messages.vue?d7ea2dc6